import angular from 'angular';
 import pdfViewerComponent from './pdf-viewer.component';
// import OrdersService from './orders.service';
// import ordersConfig from './orders.config';
// import SyncOrderModalController from './sync-order-modal/sync-order-modal.controller';
// import orderDetailModule from './order-detail/order-detail';

let pdfViewerModule = angular.module('app.pdfViewer',[])
  .component('pdfViewer', pdfViewerComponent)
//   .controller('SyncOrderModalController', SyncOrderModalController)
//   .service('OrdersService', OrdersService)
//   .config(ordersConfig)
  ;

export default pdfViewerModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/pdf-viewer/pdf-viewer.js
 **/